import {environment} from "../../../../environments/environment.development";
import {computed, Injectable, signal, WritableSignal} from "@angular/core";

let apiVucUrl = environment.apiVucUrl

@Injectable({
    providedIn: 'root'
})
export class EliminarTramiteService{
    textChangeEditor: WritableSignal<string | null> = signal(null);

    textEditorValido = computed(() => {
        const value = this.textChangeEditor();
        return value !== null && value.length >= 25;
    });
}
